"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Evaluation = void 0;
var BuildInEvaluation_1 = require("./BuildInEvaluation");
var SkillEvaluation_1 = require("./SkillEvaluation");
var Evaluation = /** @class */ (function (_super) {
    __extends(Evaluation, _super);
    function Evaluation() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._typeName = "Evaluation";
        _this.skill = function (config) { return _this.push(function (registry) {
            var entity = new SkillEvaluation_1.SkillEvaluation();
            config(entity);
            return "skill { " + entity.render(registry) + " }";
        }); };
        _this.buildIn = function (config) { return _this.push(function (registry) {
            var entity = new BuildInEvaluation_1.BuildInEvaluation();
            config(entity);
            return "buildIn { " + entity.render(registry) + " }";
        }); };
        _this.render = function (registry) { return _this.map(function (e) { return e(registry); }).join(" "); };
        return _this;
    }
    return Evaluation;
}(Array));
exports.Evaluation = Evaluation;
//# sourceMappingURL=Evaluation.js.map